import DashboardBody from './_components/dashboard-body.component'
import DashboardHeader from './_components/dashboard-header.component'
import DashboardProvider from './_components/dashboard.provider'
import HumanReviewRequests from './_components/human-review-requests.component'
import { WithFeatureEnabled, WithPermission, useCurrentProject } from 'src/providers/current-project.provider'

export const DashboardPage = () => {
  const { isFeatureActivated } = useCurrentProject()

  if (isFeatureActivated('dashboard-v2')) {
    return <HumanReviewRequests />
  }

  return (
    <WithFeatureEnabled featuresAccepted={['dashboard']} onFailure="redirect">
      <WithPermission
        requiredSubject={'PATIENT'}
        requiredAction={'GET'}
        onFailure={'permission-error-component'}
      >
        <DashboardProvider>
          <div className="c-flex c-flex-col c-w-full c-max-h-full c-flex-grow c-gap-4 c-min-w-[670px] c-h-full">
            <DashboardHeader />
            <DashboardBody />
          </div>
        </DashboardProvider>
      </WithPermission>
    </WithFeatureEnabled>
  )
}
